export default __webpack_public_path__ + "static/media/Screenshot (1139) 1.7c3bc568.png";